import { I18n } from "aws-amplify/utils";

const CREATE_KEY = "Create Account";

export function setAuthCreateTabAndButtonLabel(mode) {
  // mode: "create" | "join"
  const label = mode === "join" ? "Join Organization" : "Create Organization";

  I18n.putVocabularies({
    en: {
      [CREATE_KEY]: label,
    },
  });

  // Make sure language is set (important in some setups)
  I18n.setLanguage("en");
}
